import { motion } from "framer-motion";

export const SplashLoader = () => (
  <motion.div
    key="splash"
    initial={{ opacity: 1 }}
    exit={{ opacity: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
    className="fixed inset-0 z-[100] bg-white flex flex-col items-center justify-center"
    data-testid="splash-loader"
  >
    <img src="/brand/fmark-512.png" alt="FulfillFlow" className="lp-splash-mark h-24 w-24 md:h-28 md:w-28 object-contain" />
    <p className="lp-display mt-6 text-2xl font-semibold tracking-tight">
      <span className="text-[#0b1530]">Fulfill</span>
      <span className="lp-gradient-text">Flow</span>
    </p>
    <div className="mt-8 h-1 w-40 rounded-full bg-slate-100 overflow-hidden">
      <div className="lp-splash-bar h-full rounded-full bg-gradient-to-r from-sky-400 to-indigo-600" />
    </div>
  </motion.div>
);
